<template>
	<div class="pubPaypage">
	    <div class="recharge_pay mb10">
			<label class="list" v-if="parentId">
				<div class="txt" v-if="parentId == userId">推荐人：<span>无</span></div>
				<div class="txt" v-else>推荐人：<span>{{cardInfo}}</span></div>
			</label>
			<label class="list" v-else>
				<div class="txt">推荐人：<span>无</span></div>
			</label>
			<label class="list" v-for="(item,index) in lists" :key="index">
				<div class="txt">充值{{item.PAYAMT}}元送<span>{{item.GIFTAMT}}元</span><p style="font-size: 13px; color: #ff0000;">{{item.des}}</p></div>
				<input type="radio" name="count" @click="pickFn(index)" :checked="liIdx===index" />
			</label>
	    </div>
	    <div class="btn_box">
	        <button class="long_btn" @click="submit">确认充值</button>
	    </div>
		
		<!--提示框-->
		<v-tips :isshow="tipshow" :tips="tips"></v-tips>
	</div>
</template>

<script>
	import vTips from "../../common/tip"
	import api from "../../api/api"
	
	export default {
		data () {
			return {
				tipshow:false,
				tips:'',
				lists:[],
				liIdx:0,
				cardInfo: '',
				parentId: this.$route.query.parentId,
				userId: window.__CFG.UserId
			}
		},
		components:{vTips},
//		created(){
//			var parentId = this.$route.query.parentId;
//			console.log(parentId)
//		},
		mounted() {
			var that = this;
			api.rechargestyle({},(res) => {
				if(res.status == 1){
					that.lists = res.data;
				}else{
					console.log("请求失败");
					api.tipload(that,res.msg);
				}
			});

			var params = '';
			if (that.$route.query.parentId){
				params = {
					id: that.$route.query.parentId
				};
				api.getCardInfo(params,(res) => {
					if(res.status == 1){
						var reg = /^(\d{3})(\d*)(\d{3})$/;
						var str = res.data.CARDNO;
						str = str.replace(reg, function(a, b, c, d) {
							return b + c.replace(/\d/g, "*") + d;
						});
						this.cardInfo = str;
					}else{
						console.log("请求失败");
						api.tipload(that,res.msg);
					}
				});
			}

		},
		methods:{
			pickFn(e){
				this.liIdx = e;
			},
			onBridgeReady(aa){
				var that = this;
			   WeixinJSBridge.invoke(
				  'getBrandWCPayRequest', {
					 "appId":aa.appId,     //公众号名称，由商户传入     
					 "timeStamp":aa.timeStamp,         //时间戳，自1970年以来的秒数     
					 "nonceStr":aa.nonceStr, //随机串     
					 "package":aa.package,     
					 "signType":aa.signType,         //微信签名方式：     
					 "paySign":aa.paySign //微信签名 
				  },
				  function(res){
					  if(res.err_msg == "get_brand_wcpay_request:ok" ){
							// 使用以上方式判断前端返回,微信团队郑重提示：
							//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
							setTimeout(() => {
								that.$router.replace('/card/mine');
							},1500);
					  }else{
						  api.tipload(that,"支付失败！");
					  } 
			   }); 
			},
			submit(){
				var that = this;
				var parentId = that.$route.query.parentId;
				var params = {
					payType:'',
					money:'',
					giveMoney:'',
					parent_id: parentId
				};

				that.lists.forEach((item,index) => {
					if(that.liIdx == index){
						params.payType = item.ID;
						params.money = item.PAYAMT;
						params.giveMoney = item.GIFTAMT;
						params.parent_id = parentId;
					}
				});
				api.submitpay(params,(res) => {
					if(res.status == 1){
						var aa = res.data;
						if (typeof WeixinJSBridge == "undefined"){
						   if( document.addEventListener ){
							   document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
						   }else if (document.attachEvent){
							   document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady); 
							   document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
						   }
						}else{
						   that.onBridgeReady(aa);
						};
					}else{
						console.log("请求失败");
						api.tipload(that,res.msg);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/recharge/pay.vue